import React, { useEffect, useState } from "react";
import CustomHeader from "../../components/header";
import './dasboard.scss';
import { Container, Col, Row } from 'react-bootstrap';
import * as moment from "moment"
import { useNavigate } from 'react-router-dom';
import url from "../../config.js"
import { archetypesStack, techStack, cloudStack } from "../../constants/templateConstants";
import { ValidationComponent } from "../../components/new-resource-form/index.jsx";
import ImageCard from "../../components/imageCard";
import { ChatComponent } from '../../components/chatComponent';
import MultiCard from '../../components/multiCard/index.jsx';
import EmptyState from '../../components/emptyState/index.jsx';



const domain = url.domain;

const currentUser = (() => { try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch (e) { return {}; } })();
const currentUserId = String(currentUser.id || currentUser._id || '');
const isTenantAdmin = currentUser.platformRole === 'superadmin' || currentUser.tenantRole === 'admin';

function Dashboard() {
  const navigate = useNavigate()
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [editingProject, setEditingProject] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);

  // ── Share dialog state ──
  const [shareProject, setShareProject] = useState(null);   // the project being shared
  const [tenantUsers, setTenantUsers] = useState([]);       // candidates (same tenant)
  const [shareSelected, setShareSelected] = useState([]);   // selected userIds
  const [shareBusy, setShareBusy] = useState(false);
  const [shareError, setShareError] = useState('');

  const openShareModal = async (project) => {
    setShareProject(project);
    setShareError('');
    setShareSelected(Array.isArray(project.sharedWith) ? project.sharedWith.map(String) : []);
    try {
      const tenantId = currentUser.tenantId || '';
      const res = await fetch(`${domain}/api/v1/tenant/users?tenantId=${encodeURIComponent(tenantId)}`, {
        headers: { 'x-access-token': localStorage.getItem('token') },
      });
      const data = await res.json();
      const users = Array.isArray(data) ? data : (data.users || []);
      // Exclude the project owner from the candidate list.
      setTenantUsers(users.filter(u => String(u._id) !== String(project.userId)));
    } catch (e) {
      setTenantUsers([]);
      setShareError('Could not load users.');
    }
  };

  const toggleShareUser = (uid) => {
    setShareSelected(prev => prev.includes(uid) ? prev.filter(x => x !== uid) : [...prev, uid]);
  };

  const submitShare = async () => {
    if (!shareProject) return;
    setShareBusy(true);
    setShareError('');
    try {
      const res = await fetch(`${domain}/api/v1/project/${shareProject._id}/share`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', 'x-access-token': localStorage.getItem('token') },
        body: JSON.stringify({ userIds: shareSelected }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Share failed');
      // Reflect the new share list locally.
      setState(prev => ({
        ...prev,
        projects: prev.projects.map(p => p._id === shareProject._id ? { ...p, sharedWith: data.sharedWith || shareSelected } : p),
      }));
      setShareProject(null);
    } catch (e) {
      setShareError(e.message);
    } finally {
      setShareBusy(false);
    }
  };

  const [state, setState] = useState({
    resources: [],
    resource_group_name: [],
    azure_container: [],
    azure_cluster: [],
    projects: [],
    showModal: false,
    projectStep: 1,
    validationClass: '',
    projectArchetype: '',
    activeTeckStackIndex: '',
    activeCloudIndex: '',
    activeArcheIndex: '',
    projectName: '',
    projectType: '',
    cloudType: 'not-mentioned',
  })

  const [filterArchetype, setFilterArchetype] = useState('all');

 
  // ✅ ADD DELETE FUNCTION
  const deleteProject = async (project_id) => {
    try {
      // Call your backend API to delete
      const response = await fetch(`${domain}/api/v1/project/${project_id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('token')
        }
      });

      const result = await response.json();
      console.log('Delete response:', result);

      if (result.deleteProject.success) {
        // Remove from state
        setState(prevState => ({
          ...prevState,
          projects: prevState.projects.filter(p => p._id !== project_id)
        }));
        alert('Project deleted successfully!');
      } else {
        alert('Failed to delete project: ' + result.message);
      }
    } catch (error) {
      console.error('Error deleting project:', error);
      alert('Error deleting project');
    }
  };

  function getProject() {
    const requestOptions = {
      method: 'GET',
      headers: { 'x-access-token': localStorage.getItem('token') }
    };
    fetch(domain + '/api/v1/project', requestOptions)
      .then(response => response.json())
      .then(data => {
        const projectList = Array.isArray(data.projects) ? data.projects : Array.isArray(data) ? data : [];
        if (projectList.length > 0) {
          setState(prevState => ({
            ...prevState,
            projects: projectList.filter(
              project => project.projectArchetype !== "design-template" &&
                project.projectArchetype !== "migration-template" &&
                project.projectArchetype !== "integration-template"
            )
          }));
        }
      });
  }

  const gotproject = (id, name, archeType) => {
    // Encode the name — a project name can contain "/" (e.g. "SAP Sheet/Unsheet
    // Proposal"), "#" or "?", which would otherwise inject extra path segments and
    // stop the ":projName/:projId" route from matching, bouncing the user to login.
    const safeName = encodeURIComponent(name);
    if (archeType === 'smarthub-template') {
      navigate(`/AIAgentHub/SmartHub/${safeName}/${id}`);
    } else if (archeType === 'ai-template') {
      navigate(`/integrationAgent/${safeName}/${id}`);
    } else if (archeType === 'design-template') {
      navigate(`/designAgent/${safeName}/${id}`);
    } else if (archeType === 'migration-template') {
      navigate(`/migrationAgent/${safeName}/${id}`);
    } else {
      navigate(`/projectDetails/${safeName}/${id}`);
    }
  }

  function onChange(event) {
    const { name, value } = event.target;
    setState(prevState => ({ ...prevState, [name]: value }));
  }

  function getResource() {
    const requestOptions = {
      method: 'GET',
      headers: { 'x-access-token': localStorage.getItem('token') }
    };
    fetch(domain + '/api/v1/azresource', requestOptions)
      .then(response => response.json())
      .then(data => {
        setState(prevState => ({ ...prevState, resources: data }))
        if (data.length) {
          data.map((res) => {
            var resources = state.resource_group_name.concat(res.resource_group_name);
            setState(prevState => ({ ...prevState, resource_group_name: resources }))
          });
        }
      });
  }

  useEffect(() => {
    getResource();
    getProject()
  }, [])

  const submit = () => {
    if (!state.projectName || state.projectName === '') {
      setState(prevState => ({ ...prevState, validationClass: 'validation-error' }))
    } else {
      setState(prevState => ({ ...prevState, projectStep: 1 }))
      handleClose();
      var postObj = {
        "cloudType": state.cloudType,
        "createdOn": moment().format("DD-MM-YYYY hh:mm:ss"),
        "projectName": state.projectName,
        "projectType": state.projectType,
        "projectArchetype": (!state.projectArchetype || state.projectArchetype === '') ? state.projectType + '-template' : state.projectArchetype,
        "processType": (state.projectArchetype === "apix-mule-multi-tier" || state.projectArchetype === "apix-education-multi-tier" || state.projectArchetype === "apix-banking-multi-tier" || state.projectArchetype === "open-finance-multi-tier" || state.projectArchetype === "api-general-apis") ? "multiple" : "single"
      }

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-access-token': localStorage.getItem('token') },
        body: JSON.stringify(postObj)
      };
      fetch(domain + '/api/v1/project', requestOptions)
        .then(response => response.json())
        .then(data => {
          getProject();
        });
    }
  }

  const handleOpen = () => {
    setState(prevState => ({ ...prevState, showModal: true }))
  }

  const handleClose = () => {
    setState(prevState => ({ ...prevState, showModal: false }))
  }

  const next = () => {
    setState(prevState => ({ ...prevState, validationClass: '' }))
    let projectStep = state.projectStep;
    setState(prevState => ({ ...prevState, validationClass: 'valid' }))

    switch (projectStep) {
      case 1:
        if (!state.projectType || state.projectType === '') {
          setState(prevState => ({ ...prevState, validationClass: 'validation-error' }))
          return
        }
        break;
      case 2:
        if (!state.cloudType || state.cloudType === '') {
          setState(prevState => ({ ...prevState, validationClass: 'validation-error' }))
          return
        }
        break;
      case 3:
        if (!state.projectName || state.projectName === '') {
          setState(prevState => ({ ...prevState, validationClass: 'validation-error' }))
          return
        }
        break;
      case 4:
        if (!state.projectArchetype || state.projectArchetype === '') {
          setState(prevState => ({ ...prevState, validationClass: 'validation-error' }))
          return
        }
        break;
      default:
        break;
    }
    setState(prevState => ({ ...prevState, projectStep: projectStep + 1 }))
  }

  const prev = () => {
    let projectStepTemp = state.projectStep;
    setState(prevState => ({ ...prevState, projectStep: projectStepTemp - 1 }))
  }

  const projectStepLength = () => {
    return (state.projectType === 'mule' ? 4 : 3);
  }

  const setSelectedArchetype = (index, val) => {
    setState(prevState => ({ ...prevState, projectArchetype: archetypesStack[archetypesStack.map((item, i) => item.name === val ? i : '').filter(String)].value }))
    setState(prevState => ({ ...prevState, activeArcheIndex: index }))
  }

  const getModalBody = () => {
    switch (state.projectStep) {
      case 1:
        const setProjectType = (index, item) => {
          setState(prevState => ({ ...prevState, projectType: item }))
          setState(prevState => ({ ...prevState, activeTeckStackIndex: index }))
        }
        return (
          <div className="modal-step">
            <div className="modal-step-header">
              <h3>Select Project Type</h3>
              {state.validationClass !== '' && state.validationClass !== 'valid' ?
                <ValidationComponent message='please select a project type' /> : null}
            </div>
            <div className="modal-step-body">
              <Row className="option-grid">
                {techStack.length && techStack.map((techItem, index) => {
                  return (
                    <ImageCard
                      key={index}
                      className={index === state.activeTeckStackIndex ? 'active' : ''}
                      data={techItem}
                      onClick={(val) => setProjectType(index, val)}
                      gridVal="4"
                      index={index}
                    />
                  )
                })}
              </Row>
            </div>
          </div>
        )
      case 2:
        const setCloudType = (index, item) => {
          setState(prevState => ({ ...prevState, cloudType: item }))
          setState(prevState => ({ ...prevState, activeCloudIndex: index }))
        }
        return (
          <div className="modal-step">
            <div className="modal-step-header">
              <h3>{state.projectType === 'mule' ? 'CI/CD Server' : 'Cloud Type'}</h3>
              {state.validationClass !== 'valid' ?
                <ValidationComponent message='please select a value here' /> : null}
            </div>
            <div className="modal-step-body">
              <Row className="option-grid">
                {cloudStack.length && cloudStack.map((cloudItem, index) => {
                  return (
                    <ImageCard
                      key={index}
                      className={index === state.activeCloudIndex ? 'active' : ''}
                      data={cloudItem}
                      onClick={(val) => setCloudType(index, val)}
                      gridVal="4"
                      index={index}
                    />
                  )
                })}
              </Row>
            </div>
          </div>
        )
      case 3:
        return (
          <div className="modal-step">
            <div className="modal-step-header">
              <h3>Project Name</h3>
              {state.validationClass !== 'valid' ?
                <ValidationComponent message='please provide a value here' /> : null}
            </div>
            <div className="modal-step-body">
              <input
                className={"project-name-input " + state.validationClass}
                placeholder="Enter project name"
                name='projectName'
                onChange={onChange}
              />
            </div>
          </div>
        )
      case 4:
        return (
          <div className="modal-step">
            <div className="modal-step-header">
              <h3>Select Mule Project Template</h3>
            </div>
            <div className="modal-step-body template-scroll">
              <Row className="option-grid">
                {archetypesStack.length && archetypesStack.map((archeItem, index) => {
                  return (
                    <ImageCard
                      key={index}
                      className={index === state.activeArcheIndex ? 'active' : ''}
                      data={archeItem}
                      onClick={(val) => setSelectedArchetype(index, val)}
                      gridVal="4"
                      index={index}
                    />
                  )
                })}
              </Row>
            </div>
          </div>
        )
      default: break;
    }
  }

  // Filter projects
  const filteredProjects = state.projects.filter(project => {
    const matchesSearch = project.projectName.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesType = filterType === 'all' || project.projectType === filterType;
    const matchesArchetype = filterArchetype === 'all' || project.projectArchetype === filterArchetype;
    return matchesSearch && matchesType && matchesArchetype;
  });

  return (
    <div className="root">
      <CustomHeader />
      <main className="content">
        <div className="dashboard-container">
          {!state.showModal && (
            <Container fluid className="dashboard-content">
              <Row className="dashboard-row">
                {/* Main Content - Full Width */}
                <Col lg={12} className="main-column">
                  {/* Header Section */}
                  <div className="dashboard-header">
                    <div className="header-content">
                      <h1>Projects</h1>
                      <p className="subtitle">Manage your development projects and workflows</p>
                    </div>
                  </div>

                  {/* Filters Row - More Compact */}
                  {/* <div className="dashboard-toolbar">
                  <div className="search-filter-group">
                    <div className="search-wrapper">
                      <input
                        type="text"
                        placeholder="Search projects..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                      />
                    </div>
                    <select
                      className="filter-select"
                      value={filterType}
                      onChange={(e) => setFilterType(e.target.value)}
                    >
                      <option value="all">All Types</option>
                      <option value="mule">MuleSoft</option>
                      <option value="react">React</option>
                      <option value="spring">Spring Boot</option>
                    </select>
                    <select
                      className="filter-select"
                      value={filterArchetype}
                      onChange={(e) => setFilterArchetype(e.target.value)}
                    >
                      <option value="all">All Templates</option>
                      <option value="migration-template">Migration</option>
                      <option value="design-template">Design</option>
                      <option value="ai-template">AI Template</option>
                      <option value="integration-template">Integration</option>
                    </select>
                  </div> */}

                  {/* Results count - inline with filters */}
                  {/* <span className="results-count">
                    {filteredProjects.length} {filteredProjects.length === 1 ? 'project' : 'projects'}
                  </span>
                </div> */}

                  {/* Projects Grid */}
                  <div className="projects-grid-container">
                    <div className="projects-grid">
                      {filteredProjects && filteredProjects.length >= 1 ? (
                        filteredProjects.map((project) => {
                          // Ownership: prefer backend flags, fall back to comparing userId.
                          const isOwner = project.isOwner !== undefined
                            ? project.isOwner
                            : String(project.userId) === currentUserId;

                          const headerData = {
                            [project.projectType]: project.projectName
                          };

                          const footerData = {
                            'Cloud': project.cloudType || 'not-mentioned',
                            'Created': moment(project.createdAt).format('MMM D, YYYY'),
                            // Show who owns it when it isn't the current user's own project.
                            ...(isOwner ? {} : { 'Owner': project.ownerName || project.ownerEmail || 'Another user' })
                          };

                          const canShare = isOwner || isTenantAdmin;
                          const canDelete = isOwner; // view-only for shared users / admins

                          return (
                            <MultiCard
                              key={project._id}
                              headerData={headerData}
                              footerData={footerData}
                              theme="dark"
                              showDelete={canDelete}
                              onClick={() => gotproject(project._id, project.projectName, project.projectArchetype)}
                              onShare={canShare ? (() => openShareModal(project)) : undefined}
                              onDelete={(headerData, footerData) => {
                                const projectName = Object.values(headerData)[0];

                                if (window.confirm(`Are you sure you want to delete "${projectName}"?`)) {
                                  deleteProject(project._id);
                                }
                              }}
                            />
                          )
                        })
                      ) : (

                        <EmptyState
                          title="No Projects Found"
                          description={searchTerm ? 'Try a different search term' : 'Create your first project to get started'}
                          icon="folder"
                        />
                      )}

                    </div>
                  </div>
                </Col>
              </Row>

              {/* Floating Chat Button - Bottom Right */}
              {/* <div className="chat-fab-wrapper">
                <ChatComponent
                  onFieldUpdate={(field, value) => {
                    setState(prev => ({ ...prev, [field]: value }));
                  }}
                  submit={submit}
                />
              </div> */}
            </Container>
          )}

          {/* Modal remains same */}
          {state.showModal && (
            <div className="create-project-modal">
              {/* ... modal code ... */}
            </div>
          )}

          {/* Share project dialog */}
          {shareProject && (
            <div className="share-modal-overlay" onClick={() => setShareProject(null)}
              style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 1200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div onClick={(e) => e.stopPropagation()}
                style={{ width: 'min(460px, 92vw)', maxHeight: '80vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', background: '#0f1b28', border: '1px solid #2a3f57', borderRadius: 12, padding: 20, color: '#E5EAEF' }}>
                <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>Share project</div>
                <div style={{ fontSize: 13, color: '#8aa0b6', marginBottom: 14 }}>
                  Give view access to teammates in your tenant — “{shareProject.projectName}”.
                </div>
                <div style={{ overflowY: 'auto', flex: 1, border: '1px solid #22364b', borderRadius: 8 }}>
                  {tenantUsers.length === 0 ? (
                    <div style={{ padding: 16, color: '#6b849a', fontSize: 13 }}>No other users in this tenant.</div>
                  ) : tenantUsers.map(u => {
                    const uid = String(u._id);
                    const name = [u.firstName, u.lastName].filter(Boolean).join(' ') || u.username || u.email;
                    const checked = shareSelected.includes(uid);
                    return (
                      <label key={uid} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid #17293a' }}>
                        <input type="checkbox" checked={checked} onChange={() => toggleShareUser(uid)} />
                        <span style={{ display: 'flex', flexDirection: 'column' }}>
                          <span style={{ fontSize: 14 }}>{name}</span>
                          <span style={{ fontSize: 12, color: '#6b849a' }}>{u.email}</span>
                        </span>
                      </label>
                    );
                  })}
                </div>
                {shareError && <div style={{ color: '#ef4444', fontSize: 13, marginTop: 10 }}>{shareError}</div>}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 16 }}>
                  <button onClick={() => setShareProject(null)} disabled={shareBusy}
                    style={{ padding: '9px 16px', borderRadius: 8, background: 'transparent', border: '1px solid #2a3f57', color: '#a9b7c6', cursor: 'pointer' }}>Cancel</button>
                  <button onClick={submitShare} disabled={shareBusy}
                    style={{ padding: '9px 16px', borderRadius: 8, background: '#2EBFA5', border: 'none', color: '#04121a', fontWeight: 700, cursor: 'pointer' }}>
                    {shareBusy ? 'Saving…' : 'Save'}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export default Dashboard;